import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "1.5rem",
    height: "1.5rem",
    fillOpacity: "0.87",
  },
});

const PreciseIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 25 25" className={styles.icon}>
      <path d="M12.191 0C9.81763 0 7.49756 0.703788 5.52417 2.02236C3.55078 3.34094 2.01271 5.21509 1.10446 7.4078C0.196205 9.60051 -0.0414349 12.0133 0.421588 14.3411C0.88461 16.6689 2.0275 18.8071 3.70573 20.4853C5.38396 22.1635 7.52215 23.3064 9.84993 23.7694C12.1777 24.2324 14.5905 23.9948 16.7832 23.0866C18.9759 22.1783 20.8501 20.6402 22.1686 18.6668C23.4872 16.6935 24.191 14.3734 24.191 12C24.191 8.8174 22.9267 5.76515 20.6763 3.51472C18.4259 1.26428 15.3736 0 12.191 0V0ZM12.191 21.6C10.2923 21.6 8.43625 21.037 6.85754 19.9821C5.27882 18.9272 4.04837 17.4279 3.32177 15.6738C2.59517 13.9196 2.40505 11.9894 2.77547 10.1271C3.14589 8.26492 4.0602 6.55436 5.40278 5.21177C6.74537 3.86919 8.45593 2.95488 10.3181 2.58446C12.1804 2.21404 14.1106 2.40416 15.8648 3.13076C17.6189 3.85736 19.1183 5.08781 20.1731 6.66653C21.228 8.24524 21.791 10.1013 21.791 12C21.791 13.2607 21.5427 14.509 21.0603 15.6738C20.5778 16.8385 19.8707 17.8968 18.9792 18.7882C18.0878 19.6797 17.0295 20.3868 15.8648 20.8692C14.7 21.3517 13.4517 21.6 12.191 21.6ZM12.791 6H10.991V13.2L17.291 17L18.191 15.5L12.791 12.3V6Z" />
    </SvgIcon>
  );
};

export default memo(PreciseIcon);
